import { Outlet, Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
// import { useContext } from "react";
// import { AppStateContext } from "../../state/AppProvider";

import simbawhitebg from "../../assets/simbalogowhitebg.png";
// import simbalogodark from "../../assets/simbalogodark.png";
import sstllogo from "../../assets/sstllogo.svg";

const Layout = () => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    // const appStateContext = useContext(AppStateContext);

    return (
        <div className="flex flex-col h-full">
            <div className="bg-sstl-white z-[100] block header" id={"header"}>
                {activeAccount ? (
                    <div className="items-center justify-between border-sstl-light-grey border-solid flex lg:h-[107px] md:h-[91px] h-[64px] p-4 mx-16 relative border-0 lg:border-b">
                        <Link to="https://www.sstl.co.uk/" className="">
                            <img src={sstllogo} alt="Company Logo" className="md:w-[170px] w-[120px]" />
                        </Link>
                    </div>
                ) : (
                    <div className="items-center border-sstl-light-grey border-solid flex justify-center lg:h-[107px] md:h-[91px] h-[64px] relative border-0 lg:border-b">
                        <Link to="/" className="h-full items-center text-black flex text-sm font-semibold gap-7 leading-4">
                            <img src={simbawhitebg} alt="Placeholder Logo" className="h-full py-3 px-4" />
                        </Link>
                        {/* <Link to="/" className="h-full py-3 px-4">
                            <div className="h-full circle-header">
                                <img src={simbalogodark} alt={appStateContext?.state?.assistant?.name} className="cursor-pointer" />
                            </div>
                        </Link> */}
                    </div>
                )}
            </div>
            <Outlet />
        </div>
    );
};

export default Layout;
